@if (isShowAllSwoEnabled$ | async) {
<div class="show-all-toggle">
	<tlk-slide-toggle logChange id="show-from-all-doctors" (changeEvent)="valueChanges($event)" [checked]="isShowAllToggleEnabled$ | async"></tlk-slide-toggle>
	<span>{{ showAllTranslation$ | async }}</span>
</div>
}